import { connect } from 'react-redux'
import ChangePassword from '../components/ChangePassword'
import { reduxForm } from 'redux-form'
import { browserHistory } from 'react-router'

import { verifTokenChangePassword, changePassword } from '../../user/UserActions'
import { addNotifSuccess, addNotifError } from '../../notification/NotificationActions'

import request from '../../utils/request'


const mapStateToProps = (state) => {
    return {
        user : state.user,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        verifTokenChangePassword: (token) => {
            return dispatch(verifTokenChangePassword(token)).catch(function(){
                browserHistory.push('/login')
            })
        }
    }
}

const validate = values => {
  const errors = {} 

  if (values.password != values.confirm_password) {
    errors.confirm_password = 'Les mots de passe ne sont pas identique'
  }

  return errors
}

const config = {
    form: 'ChangePassword',
    onSubmit: (values, dispatch, props) => {
       return dispatch(changePassword(props.params.token, values['password']))
       .then((response) => {
             browserHistory.push('/reset-confirmation')
        })
        .catch((error) => {
            dispatch(addNotifError("Veuillez recommencer.", "Erreur"))
        })
    },
    validate
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(config)(ChangePassword))



// WEBPACK FOOTER //
// ./src/user/containers/ChangePasswordContainer.js